export const MODIFY_PENDING_INVITES = 'MODIFY_PENDING_INVITES';

export function modifyPendingInvites(pendingInvites){
    return{
        type: MODIFY_PENDING_INVITES,
        mainState: {
            pendingInvites: pendingInvites
        }
    }
}